export const TRACK_ANALYTICS_EVENT = "@@analytics/TRACK_ANALYTICS_EVENT";

export function trackAnalyticsEvent(eventName, eventData) {
  return {
    type: TRACK_ANALYTICS_EVENT,
    event: eventName,
    eventData
  };
}
